// extracted by mini-css-extract-plugin
export default {"root":"Tile_root__cvpon","value":"Tile_value__cbMJO","label":"Tile_label__YF+Cz","additional":"Tile_additional__dnUka"};